export const SMSPINDeliveryPreference = 'sms';
export const VoicePINDeliveryPreference = 'voice';
export const EmailPINDeliveryPreference = 'email';
export const DEFAULT_NAMESPACE = "axn";

export const EMAIL_METHOD = 'Email';
export const PHONE_METHOD = 'Phone';
export const SMALL_DEVICE = 'sd';